import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login-error" }
const _hoisted_2 = { class: "login-error__header" }
const _hoisted_3 = { class: "login-error__content" }
const _hoisted_4 = { class: "login-error__title" }
const _hoisted_5 = { class: "login-error__text" }

import { useRouter } from 'vue-router';

import Logo from '@exchange/assets/one-trading-white-logo.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginError',
  setup(__props) {

const router = useRouter();

const goHome = () => {
  router.push({ name: 'exchange' });
};

return (_ctx: any,_cache: any) => {
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(_unref(Logo), { class: "login-error__logo" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('views.loginError.title')), 1),
      _createElementVNode("p", _hoisted_5, [
        _createTextVNode(_toDisplayString(_ctx.$t('views.loginError.text')) + " ", 1),
        _createVNode(_component_x_button, {
          class: "login-error__link",
          variant: "link",
          size: "text-like",
          onClick: goHome
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('views.loginError.link')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})